import Setting from '../../../containers/SettingContainer'
// ------------------------------------
// Constants
// ------------------------------------

function fetchPostsRequest () {
  return {
    type: 'FETCH_PRODUCT_DETAIL_REQUEST'
  }
}

function fetchPostsSuccess (payload) {
  return {
    type: 'FETCH_PRODUCT_DETAIL_SUCCESS',
    payload
  }
}

function fetchPostsError () {
  return {
    type: 'FETCH_PRODUCT_DETAIL_ERROR'
  }
}

const initialState = {}
export default function productdetailReducer (state = initialState, action) {
  switch (action.type) {
    case 'FETCH_PRODUCT_DETAIL_REQUEST':
      return state
    case 'FETCH_PRODUCT_DETAIL_SUCCESS':
      return { ...state, productDetail: action.payload }
    default:
      return state
  }
}

export function fetchPostsWithReduxProductDetail (slugProductName) {
  return (dispatch) => {
    dispatch(fetchPostsRequest())
    return fetchPosts(slugProductName).then(([response, json]) => {
      if (response.status === 200) {
        dispatch(fetchPostsSuccess(json))
      } else {
        dispatch(fetchPostsError())
      }
    })
  }
}

function fetchPosts (slugProductName) {
  const URL = Setting.urlApi + 'productdetail/' + slugProductName
  return fetch(URL, { method: 'GET' })
    .then(response => Promise.all([response, response.json()]))
}


// WEBPACK FOOTER //
// ./src/routes/ProductDetail/modules/productdetail.js